/**
 * Report Service Switch
 * Uses mock data when VITE_ENABLE_MOCK_DATA is true, otherwise real API.
 */
import config from '../config/config';

import * as realService from './reportService';
import * as mockService from './mockReportService';

const svc = config.features.enableMockData ? mockService : realService;

export const getReports = svc.getReports;
export const getReportById = svc.getReportById;
export const createReport = svc.createReport;
export const updateReport = svc.updateReport;
export const archiveReport = svc.archiveReport;
